import { Category } from "./model";


export const DEFAULT_CATEGORIES = [
    new Category("Entertaiment"),
    new Category("Groceries"),
    new Category("Transport"),
];


